import Vue from 'vue';
import VueRouter from 'vue-router';
import home from '@/components/content/home/home_gd1';
import clear from '@/components/content/clear/Clear';

Vue.use(VueRouter)


// let router = new Router({
// });
const router = new VueRouter({
    mode: 'hash',
    routes: [
      {
        path: '/',
        name: 'home',
        component: home
      },
      {
        path: '/clear',
        name: 'clear',
        component: clear
      }
    ]
})

export default router
//router.start(home,'#app');



// WEBPACK FOOTER //
// ./src/router/index.js